const handleStartLoad = (state, action) => {
  const { id } = action

  const loading = [...new Set([...state.loading, id])]

  return { ...state, loading }
}

const handleEndLoad = (state, action) => {
  const { id, data } = action

  const loading = state.loading.filter(x => x !== id)
  const cache = { ...state.cache, [id]: data }

  return { ...state, loading, cache }
}

export const initialState = { loading: [], cache: {} }

export const Actions = {
  START_LOAD: 'START_LOAD',
  END_LOAD: 'END_LOAD'
}

const Handlers = {
  [Actions.START_LOAD]: handleStartLoad,
  [Actions.END_LOAD]: handleEndLoad
}

export const SimpleCacheReducer = (state, action) => {
  const { type } = action

  if (type in Handlers) {
    return Handlers[type](state, action)
  }

  throw new Error(`Unknown SimpleCache reducer type: ${type}`)
}
